import { render, staticRenderFns } from "./AddChannel.vue?vue&type=template&id=a9d6581c&"
import script from "./AddChannel.vue?vue&type=script&lang=js&"
export * from "./AddChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports